import { Skeleton } from "../../components/ui/skeleton";

export default function DownloadsPaketeSkeleton() {
  return (
    <div className="min-h-screen bg-slate-50 relative overflow-hidden font-sans">
      <div className="max-w-7xl mx-auto px-6 py-12 relative z-10">

        {/* Navigation Tabs Skeleton */}
        <div className="flex justify-center mb-16">
          <div className="bg-white/50 backdrop-blur-xl p-1.5 rounded-2xl border border-white flex gap-2">
            <Skeleton className="h-12 w-40 rounded-xl" />
            <Skeleton className="h-12 w-48 rounded-xl" />
          </div>
        </div>

        {/* Pricing Grid Skeleton */}
        <div className="flex flex-col lg:flex-row items-stretch justify-center gap-0 bg-white rounded-[2rem] overflow-hidden shadow-2xl border border-slate-100">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex-1 flex flex-col border-r border-slate-100 last:border-r-0">
               {/* Header Section */}
               <div className="h-48 bg-slate-100 p-10 flex flex-col items-center justify-center space-y-4">
                 <Skeleton className="h-4 w-20" />
                 <Skeleton className="h-12 w-32" />
                 <Skeleton className="h-3 w-16" />
               </div>

               {/* Content Section */}
               <div className="p-8 space-y-10">
                  <div className="flex flex-col items-center space-y-6">
                    <div className="space-y-2 text-center">
                      <Skeleton className="h-6 w-12 mx-auto" />
                      <Skeleton className="h-3 w-24 mx-auto" />
                    </div>
                    <div className="w-full h-px bg-slate-50" />
                    <div className="w-full space-y-8">
                       {[...Array(3)].map((_, j) => (
                         <div key={j} className="flex flex-col items-center space-y-2">
                            <Skeleton className="w-5 h-5 rounded-full" />
                            <Skeleton className="h-3 w-3/4 mx-auto" />
                         </div>
                       ))}
                    </div>
                  </div>
                  <Skeleton className="h-14 w-full rounded-xl" />
               </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
